/**
 * File: defaultValues.js
 * Project: Thales-Factory
 * File Created: Tuesday, 20th June 2023 10:26:21 am
 * Author: Ricardo Fernández Cuesta (ricardo.fernandez@aerin.es)
 * Version: 1.0.0
 * -----
 * Last Modified: Wednesday, 22nd April 2026 2:11:24 pm
 * Modified By: Pablo Araujo Cañas
 * -----
 * Copyright (c) 2023 - 2026 Aerin Sistemas S. L. copying, distribution or modification not authorised in writing is prohibited.
 */

/*
IMPORTANTE: No editar este archivo en noname-base-frontend 
debido a que al copiar el modulo este lo reemplazara.
*/

/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
import { menusByPermissions, isSuperUserMenus } from 'helpers/Utils';

const useSuperUserMenus = process.env.REACT_APP_USE_SUPERUSER === 'true';

export const menuFunction = useSuperUserMenus
  ? isSuperUserMenus
  : menusByPermissions;

export const defaultMenuType = 'menu-hidden';

// Variable de la paginación de tablas
export const defaultMaxSize = 8;

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'es';
export const localeOptions = [
  { id: 'en', name: 'English - LTR', direction: 'ltr' },
  { id: 'es', name: 'Español', direction: 'ltr' },
];

export const adminRoot = '/app';
export const databaseSelected = ''; // 'thalesfactory';
export const loginRoot = '/user/login';
export const permissionDenied = '/app/importexport/home';

export const searchPath = `${adminRoot}/pages/miscellaneous/search`;

/* URLs usadas en la demo de los templates de gogo-react */
export const firebaseConfig = {
  apiKey: 'AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg',
  authDomain: 'gogo-react-login.firebaseapp.com',
  databaseURL: 'https://gogo-react-login.firebaseio.com',
  projectId: 'gogo-react-login',
  storageBucket: 'gogo-react-login.appspot.com',
  messagingSenderId: '216495999563',
};
export const buyUrl = 'https://1.envato.market/k4z0';
export const servicePath = 'https://api.coloredstrategies.com';
/* ###################################################### */

export const themeColorStorageKey = 'light.thalesimport';
export const isMultiColorActive = false;
export const defaultColor = 'light.thalesimport';
export const isDarkSwitchActive = false;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = false;
export const colors = [
  /*
  "blue",
  "bluenavy",
  "blueyale",
  "blueolympic",
  "greenmoss",
  "greenlime",
  "purplemonster",
  "orangecarrot",
  "redruby",
  "yellowgranola",
  "greysteel",
  */
  'bluenoname',
  'pinknoname',
  'greennoname',
  'orangenoname',
];

export const adminMenus = [''];
export const customFilter = '';
export const actualRedirect = '/administration';
